<template>
  <article class="queue-up-scan-page text-center">
    <v-row justify="center">
      <v-col cols="12"
             sm="12"
             md="4">
        <h3 class="queue-up-scan-page_header font-weight-light"
            v-html="QUEUE_UP_SCAN_DATA.headerText"/>
        <div id="queue-up-scan-page qrcode-section text-center">
          <img id="queue-up-scan-page_qrcode_section_image"/>
        </div>
        <h3 class="queue-up-scan-page_footer font-weight-light"
            v-html="QUEUE_UP_SCAN_DATA.footerText"/>
        <v-btn
            v-if="QUEUE_UP_SCAN_DATA.confirmButtonText"
            type="input"
            color="teal"
            font-color="white"
            @click="goToConfirmPage"
            class="mt-4 white--text">
          {{ QUEUE_UP_SCAN_DATA.confirmButtonText }}
        </v-btn>
      </v-col>
    </v-row>
  </article>
</template>

<script>
import {mapGetters} from "vuex";
import QRCode from 'qrcode';

const qrCodeGeneratorOptions = {
  errorCorrectionLevel: 'M',
  type: 'image/jpeg',
  quality: 2
};


export default {
  name: "Queue-Up-Scan-Page",
  beforeCreate() {
    this.$store.dispatch('GET_QUEUE_UP_SCAN_DATA', {
      tenantCode: this.$route.params.tenantCode,
      code: this.$route.params.code
    });
  },
  mounted: function () {
    window.setInterval(() => {

      if (this.$route.name !== 'Scan') {
        return;
      }

      this.$store.dispatch('GET_QUEUE_UP_SCAN_DATA', {
        tenantCode: this.$route.params.tenantCode,
        code: this.$route.params.code
      });
    }, 10000);
  },
  beforeUpdate() {
    this.generateQRCode();
  },
  computed: {
    ...mapGetters([
      'QUEUE_UP_SCAN_DATA',
    ])
  },
  methods: {
    generateQRCode() {
      QRCode.toDataURL(this.QUEUE_UP_SCAN_DATA.url, qrCodeGeneratorOptions, (err, url) => {
        if (err) {
          throw new Error(err);
        }
        const img = document.getElementById('queue-up-scan-page_qrcode_section_image');
        img.src = url

      })
    },
    goToConfirmPage() {
      this.$router.push({
        path: this.QUEUE_UP_SCAN_DATA.url.replace("https://tools.quasiris.de", " ").trim()
      });
    },
  }
}
</script>

<style scoped>

</style>
